import React, {ReactNode} from "react";
import {I18nGlobals} from "../../translation/i18nInterface";
import {MessageGlobals} from "../../log/MessageInterface";
import AbstractContext from "../../AbstractContext";
import LogoutDialog from "./LogoutDialog";
import LoginDialog from "./LoginDialog";
import {LoginType} from "../../models/LoginType";
import {HelperGlobals} from "../../components/Helper";
import RefreshDialog from "./RefreshDialog";
import FunctionHelper from "../../helper/FunctionHelper";
import ReconnectDialog from "./ReconnectDialog";
import ConfirmDialog from "./ConfirmDialog";
import PortalPureComponent from "../../components/PortalPureComponent";
import StorageItem from "../../StorageItem";

export interface DialogsGlobals {
	showLoginDialog?: boolean;
	loginParameter?: LoginType;
	showLogoutDialog?: boolean;
	showRefreshDialog?: boolean;
	showReconnectDialog?: boolean;
	reconnectDialogTries?: number;
	showConfirmDialog?: boolean;
	confirmDialogDecision?: StorageItem;
	confirmDialogMessage?: ReactNode;
	confirmDialogSubmit?: () => Promise<void>;
}

interface DialogsProperties extends DialogsGlobals, MessageGlobals, I18nGlobals, HelperGlobals {
	context: AbstractContext<any, any>
}

export default class Dialogs extends PortalPureComponent<DialogsProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let isReconnecting: boolean = FunctionHelper.applyValue(this.props.showReconnectDialog, false);

		return (
			<>
				{!isReconnecting &&
					<>
						<LoginDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showLoginDialog, false)}
									 hide={() => this.props.context.getPage().setState({showLoginDialog: false})}
									 parameter={this.props.loginParameter}/>
						<LogoutDialog {...this.props}
									  visible={FunctionHelper.applyValue(this.props.showLogoutDialog, false)}
									  hide={() => this.props.context.getPage().setState({showLogoutDialog: false})}/>
						<RefreshDialog {...this.props}
									   visible={FunctionHelper.applyValue(this.props.showRefreshDialog, false)}
									   hide={() => this.props.context.getPage().setState({showRefreshDialog: false})}/>
						<ConfirmDialog {...this.props} onConfirm={this.props.confirmDialogSubmit}
									   visible={FunctionHelper.applyValue(this.props.showConfirmDialog, false)}
									   hide={() => this.props.context.getPage().setState({showConfirmDialog: false})}
									   storeDecision={this.props.confirmDialogDecision}
									   message={this.props.confirmDialogMessage}/>
					</>
				}
				<ReconnectDialog {...this.props} tries={this.props.reconnectDialogTries} visible={isReconnecting}
								 hide={() => this.props.context.getPage().setState({showReconnectDialog: false})}/>
			</>
		);
	}
}